import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateStep, setMenuModal, showModal, closeModal } from '../../store/menuModal/actions';
import Storage from '../../helpers/storage';
import { NEW_MENU_STORAGE_KEY, SERVICE_TYPES, PATHS } from '../../helpers/constants';
import { isUhuuMtkpc } from '../../helpers/uhuu';
import withProducts from '../Products';

export default function withMenuModals(WrappedComponent) {
  const mapStateToProps = state => ({
    modal: { ...state.menuModal },
  });

  const mapDispatchToProps = dispatch => ({
    updateStep: step => dispatch(updateStep(step)),
    setMenu: (name, menu) => dispatch(setMenuModal(name, menu)),
    showModal: (type, menu) => dispatch(showModal(type, menu)),
    closeModal: () => dispatch(closeModal()),
  });

  /* eslint-disable react/prop-types */
  class MenuModalsContainer extends PureComponent {
    onClickMenuActions = (value, menu, marketplaces = []) => {
      switch (value) {
        case 'edit':
          this.editMenuAction(menu, marketplaces);
          this.props.history.push(PATHS.selectProducts);
          break;
        case 'duplicate':
          if (this.checkUhuuMktpc(menu, marketplaces)) {
            this.duplicateMenuAction(menu, marketplaces);
            this.props.history.push(PATHS.createMenuUhuu);
          } else {
            this.props.showModal(value, this.duplicateMenuAction(menu, marketplaces));
          }
          break;
        case 'delete':
          this.props.showModal('delete', menu);
          break;
        case 'edit-rules':
          if (this.checkUhuuMktpc(menu, marketplaces)) {
            this.editMenuAction(menu, marketplaces);
            this.props.history.push(PATHS.createMenuUhuu);
          } else {
            this.props.updateStep(0);
            this.props.showModal('edit-rules', menu);
          }
          break;
        case 'publish':
          this.props.showModal('publish', menu);
          break;
        default:
          break;
      }
    };

    openModal = () => {
      this.props.showModal();
      this.props.updateStep(0);
    };

    checkUhuuMktpc = (menu, marketplaces) => {
      return isUhuuMtkpc(
        marketplaces.filter(mktpc => menu.marketplaces.some(mkt => mktpc.id === mkt))
      );
    };

    editMenuAction = (menu, marketplaces) => {
      const { categories } = this.props;
      const isMktpcUhuu = this.checkUhuuMktpc(menu, marketplaces);
      Storage.setLocalStorage(
        NEW_MENU_STORAGE_KEY,
        {
          ...menu,
          categories: categories.map(cat => ({
            ...cat,
            products: cat.products.map(prod => {
              const product = this.isProductChecked(prod, menu, cat);
              return {
                ...prod,
                checked: !!product,
                salesPrice: product ? product.salesPrice : null,
                salesDescription: product ? product.salesDescription : null,
                quantity: product ? product.quantity : null,
              };
            }),
          })),
          serviceTypes: SERVICE_TYPES.filter(type => menu[type.value]),
          marketplaces: marketplaces.filter(mktpc => menu.marketplaces.some(id => id === mktpc.id)),
          account: isMktpcUhuu
            ? {
                id: menu.uhuuEvents[0].accountId,
                label: menu.uhuuEvents[0].accountName,
              }
            : null,
        },
        1000000
      );
    };

    duplicateMenuAction = (menu, marketplaces) => {
      const { categories } = this.props;
      let clearedMenu = Object.assign(
        ...Object.entries(menu).map(([key, value]) => {
          if (key === 'name') {
            return {
              [key]: `${value} - Duplicado`,
            };
          } else if (key === 'uhuuEvents') {
            return {
              [key]: [],
            };
          } else if (key === 'marketplaces') {
            return {
              [key]: marketplaces.filter(mktpc => menu.marketplaces.some(id => id === mktpc.id)),
            };
          } else if (key === 'categories') {
            return {
              [key]: categories.map(cat => ({
                ...cat,
                products: cat.products.map(prod => {
                  const product = this.isProductChecked(prod, menu, cat);
                  return {
                    ...prod,
                    checked: !!product,
                    quantity: product ? product.quantity : null,
                  };
                }),
              })),
            };
          } else {
            return {
              [key]: null,
            };
          }
        })
      );

      let duplicatedMenu = Storage.setLocalStorage(NEW_MENU_STORAGE_KEY, clearedMenu, 1000000);

      return duplicatedMenu.value;
    };

    isProductChecked = (product, menu, cat) => {
      const productToBeEdited = menu.categories
        .filter(
          category =>
            category.id === cat.id && category.products.some(prod => prod.id === product.id)
        )
        .map(cat => ({
          ...cat.products.find(prod => prod.id === product.id),
        }));

      return productToBeEdited.length ? productToBeEdited[0] : null;
    };

    render() {
      return (
        <WrappedComponent
          onClickMenuActions={this.onClickMenuActions}
          openModal={this.openModal}
          updateStep={this.props.updateStep}
          {...this.props}
        />
      );
    }
  }
  /* eslint-enable */

  const MenuModals = connect(
    mapStateToProps,
    mapDispatchToProps
  )(MenuModalsContainer);

  return compose(
    withProducts,
    withRouter
  )(MenuModals);
}



// WEBPACK FOOTER //
// ./src/containers/Modals/menu.js